import { TextureLoader, SpriteMaterial, Sprite, Group, MeshBasicMaterial, Mesh, PlaneBufferGeometry } from 'three';

export default class Beacon {
  constructor(state, view) {
    this.state = state;
    this.view = view;

    this.obj = new Group();
    const beacon = this.createBeacon();
    const label = this.createLabel(view);
    this.checkmark = this.createCheckmark();
    const raycastTarget = this.createRaycastTarget(view);

    this.obj.add(beacon);
    this.obj.add(label);
    this.obj.add(this.checkmark);
    this.obj.add(raycastTarget);

    this.minScale = 1.4;
    this.maxScale = 1.7;

      //this.minScale = 1.7;
      //this.maxScale = 2.0;
      this.obj.scale.setScalar(this.minScale);    
    this.obj.renderOrder = 3; 
  }

  createBeacon() {
    const map = new TextureLoader().load('assets/images/beacons/Beacon.png');
    const material = new SpriteMaterial({ map });
    const beacon = new Sprite(material);
    beacon.scale.setScalar(0.15); 
    return beacon;
  }

  createLabel(view) {
    // ru translation
    const map = new TextureLoader().load(`assets/images/labels/${view.name}_ru.png`, (tex) => {
      this.label.scale.set(0.00025 * tex.image.width, 0.00025 * tex.image.height, 1);
    });
    const material = new SpriteMaterial({ map });
    this.label = new Sprite(material);
    this.label.position.y -= 0.15;

    return this.label;
  }

  createCheckmark() {
    const map = new TextureLoader().load('assets/images/beacons/VisitedCheck.png');
    const material = new SpriteMaterial({ map });
    const checkmark = new Sprite(material);

    checkmark.position.set(0.08, 0.08, 0);
    checkmark.scale.set(0.05, 0.05, 1);
    checkmark.visible = false;

    return checkmark;
  }

  createRaycastTarget(view) {
    const material = new MeshBasicMaterial({ visible: false });
    const plane = new Mesh(new PlaneBufferGeometry(0.2, 0.2), material); 
    plane.name = `beacons-${view.name}`;
    return plane;
  }

  select() {
    this.state.view = this.view.name;
  }

  close(onComplete) {
    onComplete();
  }

  setCheckmarkVisible(isVisible) {
    this.checkmark.visible = isVisible;
  }

  scaleUp() {
    this.obj.scale.setScalar(this.maxScale);
  }

  scaleDown() {
    this.obj.scale.setScalar(this.minScale);
  }
}
